import { Button, Collapse } from "@mui/material";
import { NavLink } from "react-router-dom";
import { ProjectInfo } from "src/components/types";
import "./ProjectHeader.css";
import ChangeLog from "src/components/ChangeLog";
import { ExpandMore } from "@mui/icons-material";
import { canAdminProject, canSeeFeedback } from "src/components/utils";

function ProjectHeader({
  projectData,
  changeLog,
  collapsed,
  uncollapse,
}: {
  projectData: ProjectInfo;
  changeLog: {};
  collapsed: boolean;
  uncollapse: () => void;
}) {
  const projectName = projectData.project_name ?? "";

  return (
    <div className="project-header-redesign">
      <Collapse in={!collapsed}>
        <div className="project-header-redesign-main">
          <div className="project-header-redesign-main-left">
            <div className="project-header-redesign-main-title-description-container">
              <h1 className="project-header-redesign-title">{projectName}</h1>
              <h2 className="project-header-redesign-main-designer">{projectData.designer}</h2>
              <div
                className="project-header-redesign-main-description"
                dangerouslySetInnerHTML={{ __html: projectData.description ?? "" }}
              />
            </div>
            <div className="project-header-redesign-main-changelog-container">
              <ChangeLog versions={changeLog} canAdminProject={canAdminProject(projectData)} />
            </div>
          </div>
          <div className="project-header-redesign-main-right">
            <img
              src={`../gameBox/${projectData.slug}.jpg`}
              className="box-image"
              alt={`box of ${projectData.project_name}`}
            />
            <div className="project-header-redesign-main-right-buttons">
              {canSeeFeedback(projectData) ? (
                <NavLink to={"feedback"}>
                  <Button variant="contained" sx={{ width: "100%" }}>
                    Feedback Results
                  </Button>
                </NavLink>
              ) : (
                <></>
              )}
              {canAdminProject(projectData) ? (
                <NavLink to={"admin"}>
                  <Button variant="contained" sx={{ width: "100%" }}>
                    Project Administration
                  </Button>
                </NavLink>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </Collapse>
      <Collapse in={collapsed}>
        <div className="project-header-collapsed">
          <h1 className="project-header-collapsed-title">{projectName}</h1>
          <img
            src={`../gameBox/${projectData.slug}.jpg`}
            className="box-image"
            alt={`box of ${projectData.project_name}`}
          />
          {canSeeFeedback(projectData) ? (
            <NavLink to={"feedback"}>
              <Button variant="contained" sx={{}}>
                Feedback Results
              </Button>
            </NavLink>
          ) : (
            <></>
          )}
          {canAdminProject(projectData) ? (
            <NavLink to={"admin"}>
              <Button variant="contained" sx={{}}>
                Project Administration
              </Button>
            </NavLink>
          ) : (
            <></>
          )}
          <button className="project-header-uncollapse-button" onClick={() => uncollapse()}>
            <ExpandMore />
          </button>
        </div>
      </Collapse>
    </div>
  );
}

export default ProjectHeader;
